<template>
  <div class="relative h-full w-full flex items-center">
    <span
      class="absolute top-0 right-0 mr-1 mt-1 px-2 cursor-pointer"
      :class="
        loading
          ? 'text-gray-500 hover:text-gray-700'
          : 'bg-blacko-80 hover:bg-blacko-90 text-white'
      "
      @click="$emit('close')"
      >X
    </span>
    <div class="mx-auto flex justify-center items-center w-full">
      <div
        v-if="loading"
        class="mx-auto py-12 flex justify-center items-center w-full"
      >
        <loading
          :label="$store.state.dashboard.i18n.project.modals.report.waiting"
        >
          <font-awesome-icon icon="smile-beam" class="ml-2"></font-awesome-icon>
        </loading>
      </div>
      <div class="-mt-2">
        <img
          :src="endpoint"
          alt=""
          width="100%"
          height="auto"
          v-show="!hasError && !loading"
          v-tooltip="'Click to open in a new window'"
        />
      </div>
      <div class="mx-auto py-6">
        <alert
          v-if="hasError && !loading"
          :message="$store.state.dashboard.i18n.project.errors.no_report"
          level="warning"
          class="px-5 py-2"
        ></alert>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["project"],
  data() {
    return {
      loading: false,
      hasError: null,
      img: null,
    };
  },
  methods: {
    getImage() {
      this.img = new Image();
      this.img.onload = this.onLoadHandler;
      this.img.onerror = this.onErrorHandler;
      this.img.src = this.endpoint;
    },

    onLoadHandler() {
      this.hasError = false;
      this.loading = false;
    },

    onErrorHandler() {
      this.hasError = true;
      this.loading = false;
    },
  },
  computed: {
    endpoint() {
      return this.project.routes.report;
    },
  },
  mounted() {
    this.loading = true;
    this.getImage();
  },
};
</script>
